<template>
  <div :class="isApp == true ? '' : 'content'">
    <Header></Header>
    <div class="main" v-show="isApp == true ? false : true">
      <!-- <div class="main_left">
        <div class="index-buygift">
          <img src="../assets/index/btn-buygift-top.gif" alt="" />
          <a class="btn-buygift buy" href="">
            <img v-show="isbuyIconEn" src="../assets/index/buy_en.png" alt="" />
            <img v-show="isbuyIconZh" src="../assets/index/buy_zh.png" alt="" />
          </a>
        </div>
        <div class="index-transfer">
          <img src="../assets/index/btn-transfer-top.gif" alt="" />
          <a class="btn-transfer" href="">
            <img
              v-show="isbuyIconEn"
              src="../assets/index/gift_en.png"
              alt=""
            />
            <img
              v-show="isbuyIconZh"
              src="../assets/index/gift_zh.png"
              alt=""
            />
          </a>
        </div>

        <div class="side-info-wrap">
          <div class="side-info-gradient">
            <div class="dw-motion">
              <img src="../assets/index/yao.gif" alt="" />
            </div>
           <div class="xiazai">
              <div class="xia_left">
                <div class="">
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-ios.png"
                    />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank"
                    ><div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i></div
                  ></a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_center">
                    <img src="../assets/index/ma.png" alt="" />
                  </a>
                  <a href="https://apps.apple.com/my/app/bw888-big-winner-888/id1581571282" target="_blank" class="xia_left_btm">
                    <img src="../assets/index/ma2.png" alt="" />
                  </a>
                </div>
              </div>
              <div class="xia_right subb">
                <div class="" @click="goDown">
                  <a class="xia_left_top">
                    <img
                      src="../assets/index/qrcode-akp.png"
                    />
                  </a>
                  <a>
                    <div class="dianji">
                      {{ $t("index.xiaZai")
                      }}<i class="el-icon-caret-right"></i>
                    </div>
                  </a>
                  <a class="xia_left_center"
                    ><img src="../assets/index/apk.png" alt=""
                  /></a>
                </div>
              </div>
            </div>

            <div class="fbBtn_wrap" style="padding:0.2rem">
              <a href="https://t.me/Tiger777com" target="_blank">
                  <img src="../assets/index/liaotian.png" style="width:9.375rem;height:3.125rem" alt="">
                </a>
            </div>
          </div>
        </div>
      </div> -->
      <MainLeft></MainLeft>
      <div class="main_content">
        <div class="navigation">
          {{ $t('teaching.home') }}>>{{ $t('client.kefu') }}>>{{ isTitle }}
        </div>
        <div class="big_bod">
          <div class="question_title subb">
            <div
              :class="
                questionActive == index
                  ? 'question_item_title_sub'
                  : 'question_item_title'
              "
              v-for="(item, index) in questionList"
              :key="index"
              @click="changeQusetion(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="small_bod">
            <div
              v-for="(item, index) in showQuestion"
              :key="index"
              v-show="isQuestion"
            >
              <el-collapse>
                <el-collapse-item :title="item.question" name="1">
                  <div
                    class="showQuestion_item"
                    v-for="(itemSub, indexSub) in item.answer"
                    :key="indexSub"
                  >
                    {{ itemSub }}
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div v-show="isSuspension">
              <div class="suspension_search">
                <input type="text" :placeholder="this.$t('client.nameEnter')" />
                <button><i class="el-icon-search subb"></i></button>
              </div>
              <div class="suspension_list">
                <div class="suspension_list_small_sub">{{$t('client.name')}}</div>
                <div class="suspension_list_small_sub">{{$t('client.startTime')}}</div>
                <div class="suspension_list_small_sub">{{$t('client.endTime')}}</div>
                <div class="suspension_list_big_sub">{{$t('client.reason')}}</div>
              </div>
              <div
                v-for="(item, index) in suspensionList"
                :key="index"
                class="suspension_list_item"
              >
                <div class="suspension_list_small">{{ item.userId }}</div>
                <div class="suspension_list_small">{{ item.timeStart }}</div>
                <div class="suspension_list_small">{{ item.timeEnd }}</div>
                <div class="suspension_list_big">{{ item.reason }}</div>
              </div>
              <div class="suspension_fenye">
                               <el-pagination
    layout="prev, pager, next"
    :total="1000">
  </el-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="isapp" v-show="isApp == false ? false : true">
              <div class="isapp_big_bod">
          <div class="question_title subb">
            <div
              :class="
                questionActive == index
                  ? 'isapp_question_item_title_sub'
                  : 'isapp_question_item_title'
              "
              v-for="(item, index) in questionList"
              :key="index"
              @click="changeQusetion(item, index)"
            >
              {{ item.title }}
            </div>
          </div>
          <div class="isapp_small_bod">
            <div
              v-for="(item, index) in showQuestion"
              :key="index"
              v-show="isQuestion"
            >
              <el-collapse>
                <el-collapse-item :title="item.question" name="1">
                  <div
                    class="isapp_showQuestion_item"
                    v-for="(itemSub, indexSub) in item.answer"
                    :key="indexSub"
                  >
                    {{ itemSub }}
                  </div>
                </el-collapse-item>
              </el-collapse>
            </div>
            <div v-show="isSuspension">
              <div class="isapp_suspension_search">
                <input type="text" :placeholder="this.$t('client.nameEnter')" />
                <button class="suspension_search_btn"><i class="el-icon-search subb"></i></button>
              </div>
              <!-- <div class="suspension_list">
                <div class="suspension_list_small_sub">{{$t('client.name')}}</div>
                <div class="suspension_list_small_sub">{{$t('client.startTime')}}</div>
                <div class="suspension_list_small_sub">{{$t('client.endTime')}}</div>
                <div class="suspension_list_big_sub">{{$t('client.reason')}}</div>
              </div> -->
              <!-- <div
                v-for="(item, index) in suspensionList"
                :key="index"
                class="suspension_list_item"
              >
                <div class="suspension_list_small">{{ item.userId }}</div>
                <div class="suspension_list_small">{{ item.timeStart }}</div>
                <div class="suspension_list_small">{{ item.timeEnd }}</div>
                <div class="suspension_list_big">{{ item.reason }}</div>
              </div> -->
              <div>
                <div  v-for="(item, index) in suspensionList"
                :key="index"
                class="isapp_suspension_list_item">
                <div class="isapp_suspension_item">
                  <div class="suspension_item_left">昵称</div>
                  <div class="suspension_item_right">{{ item.userId }}</div>
                </div>
                <div class="isapp_suspension_item">
                  <div class="suspension_item_left">开始日期</div>
                  <div class="suspension_item_right">{{ item.timeStart }}</div>
                </div>
                <div class="isapp_suspension_item">
                  <div class="suspension_item_left">截止日期</div>
                  <div class="suspension_item_right">{{ item.timeEnd }}</div>
                </div>
                <div class="isapp_suspension_item">
                  <div class="suspension_item_left">停权原因</div>
                  <div class="suspension_item_right suspension_item_right_color">{{ item.reason }}</div>
                </div>
              </div>
              </div>
 <el-pagination
    layout="prev, pager, next"
    :total="1000">
  </el-pagination>
            </div>
            
          </div>
        </div>
    </div>
    <Login-pop ref="LoginPop"></Login-pop>
    <Footer></Footer>
    <router-view />
  </div>
</template>
<script>
import "../assets/h5/client.css";
import { mapActions, mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      isbuyIconEn: true,
      isbuyIconZh: false,
      questionActive: 0,
      isTitle: "",
      isQuestion: true,
      isSuspension: false,
      visible: false,
      isLoginShow: false,
      // questionList: [
      //   {
      //     title: "常见问题",
      //     total: [
      //       {
      //         question: "玩家等级怎么提升？",
      //         answer: [
      //           "1. 老虎机、欢乐宾果：累计押注金额达到100,000，即可升级一级",
      //           "2. 西游争霸：累计押注金额达到150,000，即可升级一级(庄、闲、和不计算在押注经验值内)",
      //           "3. 海王系列：累计押注金额达到400,000，即可升级一级",
      //           "4. 好运骰宝:累计押注金额达到150,000，即可升级一级(大、小、单骰1~6不计算在押注经验值内)"
      //         ]

      //       },
      //       {
      //         question: "忘记密码该怎么办?",
      //         answer: [
      //           "1. 点选『忘记密码』",
      //           "2. 填妥验证数据后送出",
      //           "3. 系统将会发送一组新的密码至您手机。"
      //           ],
      //       },
      //       {
      //         question: "绑定手机时，收不到验证码怎么办?",
      //         answer: [
      //           "若您迟迟未收到手机验证码短信，可在90秒后，在绑定手机画面点选「发送验证码按钮」，验証码会再次发送，但若手机短信再次发送超过二次，手机仍未绑定，则需请您联络客服中心，我们将尽快为您服务。"
      //           ],
      //       },
      //       {
      //         question: "绑定手机时，收不到验证码怎么办?",
      //         answer: [
      //           "可至游戏内『银行』->『我的存摺』->『金币』查询您的充值纪录。"
      //           ],
      //       },
      //        {
      //         question: "要如何修改会员数据?",
      //         answer: [
      //           "可至游戏内 『个人』->『个人资料』 修改您的会员数据。"
      //           ],
      //       },
      //        {
      //         question: "如何查询各项游戏纪录?",
      //         answer: [
      //           "可至游戏内『其他』->『游戏记录』->查询您的游戏纪录。"
      //           ],
      //       },
      //     ],
      //   },
      //   {
      //     title: "停权名单",
      //     total: [
      //       {
      //         userId: "jqqqqqqq",
      //         timeStart: "2022/2/28",
      //         timeEnd: "终止契约",
      //         reason: "大量新申請帳號破壞遊戲秩序者",
      //       },
      //       {
      //         userId: "aaaaaa",
      //         timeStart: "2022/2/28",
      //         timeEnd: "终止契约",
      //         reason: "大量新申請帳號破壞遊戲秩序者",
      //       },
      //     ],
      //   },
      //   {
      //     title: "客服回报",
      //   },
      // ],
      questionListEn: [
        {
          title: "常见问题",
          total: [
            {
              question: "玩家等级怎么提升？",
              answer: [
                "1. 老虎机、欢乐宾果：累计押注金额达到100,000，即可升级一级",
                "2. 西游争霸：累计押注金额达到150,000，即可升级一级(庄、闲、和不计算在押注经验值内)",
                "3. 海王系列：累计押注金额达到400,000，即可升级一级",
                "4. 好运骰宝:累计押注金额达到150,000，即可升级一级(大、小、单骰1~6不计算在押注经验值内)",
              ],
            },
            {
              question: "忘记密码该怎么办?",
              answer: [
                "1. 点选『忘记密码』",
                "2. 填妥验证数据后送出",
                "3. 系统将会发送一组新的密码至您手机。",
              ],
            },
            {
              question: "绑定手机时，收不到验证码怎么办?",
              answer: [
                "若您迟迟未收到手机验证码短信，可在90秒后，在绑定手机画面点选「发送验证码按钮」，验証码会再次发送，但若手机短信再次发送超过二次，手机仍未绑定，则需请您联络客服中心，我们将尽快为您服务。",
              ],
            },
            {
              question: "绑定手机时，收不到验证码怎么办?",
              answer: [
                "可至游戏内『银行』->『我的存摺』->『金币』查询您的充值纪录。",
              ],
            },
            {
              question: "要如何修改会员数据?",
              answer: ["可至游戏内 『个人』->『个人资料』 修改您的会员数据。"],
            },
            {
              question: "如何查询各项游戏纪录?",
              answer: ["可至游戏内『其他』->『游戏记录』->查询您的游戏纪录。"],
            },
          ],
        },
        {
          title: "停权名单",
          total: [
            {
              userId: "jqqqqqqq",
              timeStart: "2022/2/28",
              timeEnd: "终止契约",
              reason: "大量新申請帳號破壞遊戲秩序者",
            },
            {
              userId: "aaaaaa",
              timeStart: "2022/2/28",
              timeEnd: "终止契约",
              reason: "大量新申請帳號破壞遊戲秩序者",
            },
          ],
        },
        {
          title: "客服回报",
        },
      ],
      showQuestion: [],
      suspensionList: [],
    };
  },
  computed: {
    ...mapState({
      hasLogin(state) {
        return state.hasLogin;
      },
      isApp(state) {
        return state.isApp;
      },
    }),
    questionList() {
      return [
        {
          title: this.$t("client.kefu"),
          total: [
            {
              question: this.$t("client.question1"),
              answer: this.$t("client.answer1"),
            },
            {
              question: this.$t("client.question2"),
              answer: this.$t("client.answer2"),
            },
            {
              question: this.$t("client.question3"),
              answer: this.$t("client.answer3"),
            },
            {
              question: this.$t("client.question4"),
              answer: this.$t("client.answer4"),
            },
            {
              question: this.$t("client.question5"),
              answer: this.$t("client.answer5"),
            },
            {
              question: this.$t("client.question6"),
              answer: this.$t("client.answer6"),
            },
          ],
        },
        // {
        //   title: this.$t("client.suspensions"),
        //   total: [
        //     {
        //       userId: "jqqqqqqq",
        //       timeStart: "2022/2/28",
        //       timeEnd: "终止契约",
        //       reason: "大量新申請帳號破壞遊戲秩序者",
        //     },
        //     {
        //       userId: "aaaaaa",
        //       timeStart: "2022/2/28",
        //       timeEnd: "终止契约",
        //       reason: "大量新申請帳號破壞遊戲秩序者",
        //     },
        //   ],
        // },
        // {
        //   title: this.$t("client.report"),
        // },
      ];
    },
  },
  created() {
    this.showPop();
    this.questionShow();
    this.changeIcon();
  },
  methods: {
     goDown(){
     this.$router.push('/Down')
    },
    changeIcon() {
      let lang = localStorage.getItem("lang");
      if (lang == "en") {
        this.isbuyIconEn = true;
        this.isbuyIconZh = false;
      }
      if (lang == "zh") {
        this.isbuyIconEn = false;
        this.isbuyIconZh = true;
      }
    },
    showPop() {
      // console.log("1");
      this.visible = true;
    },
    changeLogin() {
      this.isLoginShow = false;
    },
    changeQusetion(e, index) {
      // console.log("questionList", e);
      this.questionActive = index;
      this.isTitle = e.title;
      if (index == 0) {
        this.showQuestion = e.total;
        this.isQuestion = true;
        this.isSuspension = false;
      }
      if (index == 1) {
        this.isSuspension = true;
        this.isQuestion = false;
        this.suspensionList = e.total;
      }
      if (index == 2) {
        if (this.hasLogin == false) {
          this.$refs.LoginPop.showLogin();
        }
      }
    },
    questionShow() {
      // console.log("----", this.questionList[0].total);
      this.showQuestion = this.questionList[0].total;
    },
  },
};
</script>
<style lang="less" scoped="">
// .content {
//   width: 100%;
//   background: #ad0000
//     url("https://www.jinjinjin777.com/static/images/bg-pc-head.jpg") center top
//     no-repeat;
//   background-size: 100% auto;
// }
.main_content {
  width: 75%;
  float: right;
}
.login_pop {
  position: relative;
  position: fixed;
  margin: auto;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  width: 25rem;
  height: 15.625rem;
  background-color: black;
  border: 0.125rem solid #e1aa3f;
  border-radius: 0.3125rem;
}
.login_title {
  background: #ffdb6b;
  background-image: linear-gradient(
    180deg,
    #dea339 0%,
    #f9cc4a 20%,
    #ffdb6b 35%,
    #ffdb6b 55%,
    #ce9631 80%,
    #8c5c0d 100%
  );
  color: #2e0100;
  font-weight: 700;
  font-size: 1.25rem;
  height: 2.25rem;
  line-height: 2.25rem;
}
.login_msg {
  width: 23.75rem;
  background-color: rgb(60, 0, 0);
  height: 12.5rem;
  margin: 0 auto;
}
.login_com {
  padding-top: 1.875rem;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: center;
}
.login_as {
  color: #f9cc4a;
  margin-right: 0.625rem;
}
.login_input input {
  height: 1.875rem;
  width: 12.5rem;
}
.login_in {
  color: #000;
  background-image: linear-gradient(
    #d5ff70 0%,
    #3b8c00 50%,
    #358000 50%,
    #296100 90%,
    #1e4600 100%
  );
  border: 0.125rem solid #a2750a;
  font-size: 1.125rem;
  padding: 0.375rem 0rem;
  font-weight: 600;
  width: 9.375rem;
  margin: 0 auto;
  margin-top: 1.25rem;
  border-radius: 0.3125rem;
}
.login_guanbi {
  position: absolute;
  top: -0.9375rem;
  right: -0.9375rem;
  .el-icon-error {
    font-size: 2.1875rem;
  }
}
.big_bod {
  width: 55.5rem;
  // height: 50rem;
  background-color: rgb(188, 152, 30);
  border: 0.125rem solid white;
  border-radius: 0.3125rem;
}
.question_title {
  display: flex;
}
.question_item_title {
  padding: 0.625rem 1.25rem;
  // border: 0.0625rem solid white;
  background: #a58416;
  color: #3a1302;
  font-size: 1.125rem;
}
.question_item_title_sub {
  padding: 0.625rem 1.25rem;
  font-size: 1.125rem;
  color: #3a1302;
  color: white;
  background-image: linear-gradient(#eade38 0%, #ccb127 50%, #bc981e 100%);
}
.small_bod {
  background-color: rgb(215, 206, 176);
  width: 96%;
  margin: 0 auto;
  padding: 0.3125rem;
  border: 0.125rem solid #3a1302a9;
  border-radius: 0.3125rem;
  margin-bottom: 0.625rem;
  margin-top: 0.625rem;
}
/deep/.el-collapse-item__header {
  background-image: linear-gradient(#fff084 0%, #ffcd48 100%);
  border: solid 0.0625rem #cc890f;
  border-radius: 0.5rem;
  color: #5b0606;
  font-weight: bold;
  width: 80%;
  margin: 0.625rem auto;
  padding: 0 0.625rem;
}
/deep/.el-collapse-item__content {
  background-color: rgb(215, 206, 176);
  padding-bottom: 0.625rem;
}
.suspension_search {
  display: flex;
  flex-direction: row;
  justify-items: flex-end;
}
.suspension_search input {
  height: 1.875rem;
}
.suspension_search button {
  height: 1.875rem;
  width: 1.875rem;
}
.suspension_list {
  margin-top: 1.25rem;
  display: flex;
  flex-direction: row;
  // justify-content: space-between;
  background-color: rgb(166, 144, 76);
  padding: 0.625rem 1.25rem;
}
.suspension_list_item {
  display: flex;
  flex-direction: row;
  padding: 0.725rem 1.25rem;
  border-bottom: 0.0625rem solid rgb(166, 144, 76);
  // justify-content: space-between;
}
.suspension_list_small {
  width: 20%;
  color: #6d2701;
}
.suspension_list_small_sub {
  width: 20%;
  color: white;
}
.suspension_list_big {
  width: 40%;
  color: red;
}
.suspension_list_big_sub {
  width: 40%;
  color: white;
}
.showQuestion_item {
  text-align: left;
  margin-left: 6.25rem;
}
/deep/ .el-collapse-item__header{
  height: auto;
  padding: 0.625rem 0;
  padding-left: 0.9375rem;
  line-height: normal;
  text-align: left;
}
/deep/ .el-pager li{
  color: white;
  min-width: 1.5938rem;
  background-color: rgb(120, 2, 0);  
}
/deep/ .el-pagination button:disabled {
  min-width: 1.5938rem;
    color: #C0C4CC;
    background-color: rgb(97, 0, 1);
    cursor: not-allowed;
}
/deep/ .el-pagination .btn-next, .el-pagination .btn-prev {
  min-width: 1.5938rem; 
    background: rgb(189, 29, 29);
    background-size: 1rem;
    cursor: pointer;
    margin: 0;
    color: white;
}
/deep/ .el-pager li.active {
  min-width: 1.5938rem;
    color: #409EFF;
    cursor: default;
    background-color: rgb(120, 2, 0);
}
/deep/ .el-pagination .btn-prev {
  color: white;
     background: #bd1d1d;
    background-size: 1rem;
    cursor: pointer;
    margin: 0;
}
/deep/ .el-collapse-item__header{
  font-size: 0.9375rem;
  font-weight: normal;
}
.suspension_fenye{
  margin-top: 0.825rem;
}
.xia_left_center img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xia_left_btm img{
  width: 5.9375rem;
  height: 1.9375rem;
}
.xiazaitu{
 width: 5.9375rem;
  height: 1.9375rem;
}
</style>
